
interface ServiceAreasSectionProps {
  onContactClick: () => void;
}

export default function ServiceAreasSection({ onContactClick }: ServiceAreasSectionProps) {
  const serviceAreas = [
    "Escondido", "San Marcos", "Vista", "Carlsbad", "Encinitas", 
    "Solana Beach", "Del Mar", "Poway", "Rancho Bernardo", "Carmel Valley", 
    "La Jolla", "Pacific Beach", "San Diego", "Chula Vista", "Oceanside",
    "El Cajon", "National City", "La Mesa", "Santee", "Lemon Grove",
    "Spring Valley", "Bonita", "Imperial Beach", "Coronado", "Mission Beach",
    "Ocean Beach", "Point Loma", "Hillcrest", "University City", "Mira Mesa",
    "Scripps Ranch", "Tierrasanta", "Serra Mesa", "Clairemont", "Bay Park",
    "Mission Valley", "Fashion Valley", "Kearny Mesa", "Linda Vista", "Allied Gardens",
    "San Carlos", "Del Cerro", "Grantville", "Mission Gorge", "Navajo",
    "College Area", "Rolando", "Talmadge", "Kensington", "Normal Heights",
    "North Park", "South Park", "Golden Hill", "Banker's Hill", "Little Italy",
    "Downtown San Diego", "Gaslamp Quarter", "East Village", "Marina District", "Midway",
    "Sports Arena", "Roseville", "Morena", "Bay Ho", "Pacific Highlands Ranch",
    "Torrey Pines", "Torrey Hills", "Carmel Creek", "Fairbanks Ranch", "Rancho Santa Fe",
    "4S Ranch", "Bernardo Heights", "Sabre Springs", "Rancho Penasquitos", "Black Mountain Ranch",
    "Miramar", "Sorrento Valley", "Sorrento Mesa", "Torrey Pines Mesa", "Eastlake",
    "Otay Ranch", "Millenia", "Rolling Hills Ranch", "Rancho San Diego", "Jamul",
    "Dulzura", "Campo", "Descanso", "Pine Valley", "Guatay",
    "Mount Laguna", "Julian", "Santa Ysabel", "Ramona", "San Pasqual",
    "Valley Center", "Pauma Valley", "Rincon", "Fallbrook", "Bonsall",
    "Rainbow", "Camp Pendleton South", "Hidden Meadows", "Deer Springs", "Harmony Grove",
    "Elfin Forest", "San Dieguito", "Olivenhain", "Cardiff", "Leucadia",
    "Temecula"
  ];

  return (
    <section id="service-areas" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Service Areas</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <p className="text-lg text-gray-700 mb-6">
              Blue Team Home Services is a one stop steam cleaning shop not only for Escondido, but also for all the cities around it throughout San Diego County.
            </p>
            
            <p className="text-lg text-gray-700 mb-6">
              <em>We serve {serviceAreas.map((area, index) => (
                <span key={area}>
                  <a href="#" className="text-teal-600 hover:text-teal-700 cursor-pointer">{area}</a>
                  {index < serviceAreas.length - 1 && ", "}
                </span>
              ))}!</em>
            </p>

            <p className="text-lg text-gray-700 mb-8">
              Contact us today to have your professional cleaning scheduled, so you can enjoy a fresh and clean environment, at home, at the office, or in your vehicle this week!
            </p>

            <div className="flex flex-col sm:flex-row gap-4 items-start">
              {/* HouseCall Pro Booking Button */}
              <div id="hcp-booking-button-service-areas"></div>
              <a 
                href="tel:+16197482446" 
                className="bg-gray-800 text-white px-8 py-3 rounded-lg font-semibold hover:bg-gray-900 transition-colors cursor-pointer flex items-center justify-center"
              >
                <i className="fa fa-phone mr-2"></i>
                (619) 748-2446
              </a>
            </div>
          </div>

          {/* Map */}
          <div className="aspect-video rounded-lg overflow-hidden shadow-lg">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d106516.17!2d-117.086394!3d33.119206!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dbee7c3efb4b85%3A0x8e58c019a6b0c9b8!2sEscondido%2C%20CA!5e0!3m2!1sen!2sus!4v1640995200000!5m2!1sen!2sus" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              allowFullScreen
              className="w-full h-full"
              title="Blue Team Home Services Location"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
